<template>
  <img
    :src="iconPath"
    :alt="decorative ? '' : (alt || name)"
    :aria-hidden="decorative ? 'true' : null"
    :class="['icon-svg', sizeClass]"
    :style="{ width: customSize, height: customSize }"
  />
</template>

<script>
import instagramIcon from "@/assets/icon/vendors/simple-icons-v16.21.0/instagram.svg";
import googleMapsIcon from "@/assets/icon/vendors/simple-icons-v16.21.0/googlemaps.svg";
import bookingIcon from "@/assets/icon/vendors/simple-icons-v16.21.0/bookingdotcom.svg";
import skyscannerIcon from "@/assets/icon/vendors/skyscanner/skyscanner-24px.svg";

const brandIconPaths = {
  "brand-instagram": instagramIcon,
  "brand-googlemaps": googleMapsIcon,
  "brand-skyscanner": skyscannerIcon,
  "brand-bookingdotcom": bookingIcon,
};

export default {
  name: "IconSvg",
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: "md", // 'xs', 'sm', 'md', 'lg', 'xl'
    },
    customSize: {
      type: String,
      default: null, // e.g., '24px', '2rem'
    },
    alt: { type: String, default: "" },
    decorative: { type: Boolean, default: false },
  },
  computed: {
    iconPath() {
      if (brandIconPaths[this.name]) return brandIconPaths[this.name];
      try {
        return require(`@/assets/icon/${this.name}.svg`);
      } catch (error) {
        console.error(`Icon not found: ${this.name}`);
        return "";
      }
    },
    sizeClass() {
      return `icon-${this.size}`;
    },
  },
};
</script>

<style scoped>
.icon-svg {
  display: inline-block;
  vertical-align: middle;
}

.icon-xs {
  width: 12px;
  height: 12px;
}

.icon-sm {
  width: 16px;
  height: 16px;
}

.icon-md {
  width: 20px;
  height: 20px;
}

.icon-lg {
  width: 24px;
  height: 24px;
}

.icon-xl {
  width: 32px;
  height: 32px;
}
</style>
